import { render, staticRenderFns } from "./AssignLom.vue?vue&type=template&id=0f429588"
import script from "./AssignLom.vue?vue&type=script&lang=js"
export * from "./AssignLom.vue?vue&type=script&lang=js"
import style0 from "./AssignLom.vue?vue&type=style&index=0&id=0f429588&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports